import * as Types from "../constants/TypeActions";

let Initstate = {
    user: {}
};

const reducer = (state = Initstate, action) => {
    switch (action.type) {
        case Types.SET_USER:
            state = {
                ...state,
                user: action.result,
            };
            return { ...state };

        default:
            return { ...state };


    }
};
export default reducer;
